module.exports = __webpack_public_path__ + "static/img/bg-03.fe136be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-03.jpg
// module id = WEmS
// module chunks = 100